export default {
	gameEngineUrl: process.env.VUE_APP_GAME_ENGINE_URL,
	handleUrl: process.env.VUE_APP_HANDLE_URL,
	loading: false
};
